<section class="service-banner">
  <div class="container">
    <div class="row">
      <div class="col-xl-11 m-auto">
        <div class="vh-100">
          <div class="d-flex flex-column justify-content-center align-items-center h-100">
            <div class="block-content">
              <div class="d-flex flex-row w-100">
                <h1 class="d-none d-sm-block d-md-block d-lg-block d-xl-block d-xxl-block" data-aos="fade-up" data-aos-duration="1000" data-aos-delay="100">Your Payment is Failed </h1>
                <div id="lottie"></div>
              </div>
              <!-- mobile -->
              <h1 class="d-block d-sm-none d-md-none d-lg-none d-xl-none d-xxl-none" data-aos="fade-up" data-aos-duration="1000" data-aos-delay="100">Your Payment is </h1>
              <h1 class="csm d-block d-sm-none d-md-none d-lg-none d-xl-none d-xxl-none" data-aos="fade-up" data-aos-duration="1000" data-aos-delay="200"> Failed</h1>
              <!-- mobile -->
            </div>
            
          </div>
          <p class="p32 head position-relative w-100 start-0  end-0 d-block d-sm-none d-md-none d-lg-none d-xl-none d-xxl-none" data-aos="fade-up" data-aos-duration="1000" data-aos-delay="100"> We do it real </p>
        </div>
      </div>
    </div>
  </div>
</section>